import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function MissionDetail({ mission }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/');
  };

  return (
    <div className="fade-in">
      <div className="hero">
        <h1>{mission.hero.title}</h1>
        <p>{mission.hero.subtitle}</p>
      </div>

      <div className="content-section container mission-detail">
        {mission.sections.map((section) => (
          <React.Fragment key={section.title}>
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            {section.listTitle && <h3>{section.listTitle}</h3>}
            {section.items?.length > 0 && (
              <ul>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}

            {section.contactPrompt && (
              <p>
                {section.contactPrompt}{' '}
                <Link to="/contact" className="mission-link">contact us here</Link>.
              </p>
            )}
          </React.Fragment>
        ))}

        {mission.contacts?.length > 0 && (
          <>
            <h3>{mission.contactsTitle}</h3>
            <ul>
              {mission.contacts.map((contact) => (
                <li key={contact.href}>
                  <strong>{contact.label}:</strong> <a href={contact.href}>{contact.value}</a>
                </li>
              ))}
            </ul>
          </>
        )}

        <div className="mission-back-wrap">
          <button type="button" className="btn btn-secondary" onClick={handleBack}>Back</button>
        </div>
      </div>
    </div>
  );
}

export default MissionDetail;
